import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowLeft = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("line", { x1: "17", y1: "10", x2: "3", y2: "10", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", "data-color": "color-2" }),
        React.createElement("polyline", { points: "8 5 3 10 8 15", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconArrowLeft.js.map